(() => {
  const PRODUCT_HANDLE = 'start-met-ontwerpen';

  /*
    Gewenste volgorde bij een set van 5 afbeeldingen:
    nieuwe 1 = oude 3
    nieuwe 2 = oude 4
    nieuwe 3 = oude 5
    nieuwe 4 = oude 1
    nieuwe 5 = oude 2
  */
  const FIVE_IMAGE_ORDER = [2, 3, 4, 0, 1];

  const isCorrectProduct = () =>
    window.location.pathname.includes(`/products/${PRODUCT_HANDLE}`);

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

  const getProductSection = () =>
    document.querySelector('[id^="ProductInfo-"]') ||
    document.querySelector('.product__info-container');

  const getSelectedOption = (kind) => {
    const root = getProductSection();
    if (!root) return '';

    const radios = [...root.querySelectorAll('input[type="radio"]:checked')];

    const match = radios.find((input) => {
      const name = normalize(input.name);
      const value = normalize(input.value);

      if (kind === 'color') {
        return (
          name.includes('kleur') ||
          name.includes('color') ||
          ['wit', 'zwart', 'oranje', 'white', 'black', 'orange'].includes(value)
        );
      }

      if (kind === 'printing') {
        return (
          name.includes('bedrukking') ||
          name.includes('printing') ||
          value.includes('blanco t-shirt') ||
          value === 't-shirt bedrukken'
        );
      }

      return false;
    });

    if (match) return normalize(match.value);

    const select = [...root.querySelectorAll('select')].find((el) => {
      const name = normalize(el.name);

      if (kind === 'color') {
        return name.includes('kleur') || name.includes('color');
      }

      return name.includes('bedrukking') || name.includes('printing');
    });

    return select ? normalize(select.value) : '';
  };

  const readTokens = (page, attribute) =>
    (page.getAttribute(attribute) || '')
      .split('|')
      .map(normalize)
      .filter(Boolean);

  const tokenMatches = (tokens, selectedValue) => {
    if (!selectedValue) return true;
    if (tokens.includes('*')) return true;
    if (!tokens.length) return false;
    return tokens.includes(selectedValue);
  };

  const pageMatchesSelection = (page, selectedColor, selectedPrinting) => {
    const colors = readTokens(page, 'data-colors');
    const printings = readTokens(page, 'data-printings');

    return (
      tokenMatches(colors, selectedColor) &&
      tokenMatches(printings, selectedPrinting)
    );
  };

  const isPrintedSelection = (selectedPrinting) => {
    const value = normalize(selectedPrinting);

    return (
      value === 't-shirt bedrukken' ||
      value.includes('t-shirt bedrukken')
    ) && !value.includes('blanco');
  };

  const isModelPage = (page) => {
    const image = page?.querySelector('img');
    if (!image) return false;

    const text = normalize(
      `${image.alt || ''} ${image.currentSrc || image.src || ''}`
    );

    /*
      Eerst kijken naar duidelijke woorden in alt-tekst/bestandsnaam.
      Daardoor kun je later ook zelf afbeeldingen als model herkennen
      met woorden zoals "model", "vrouw", "man", "couple" of "lifestyle".
    */
    const modelWords = [
      'model',
      'modellen',
      'vrouw',
      'dame',
      'man',
      'heer',
      'couple',
      'koppel',
      'lifestyle',
      'wearing',
      'gedragen',
      'persoon',
      'personen'
    ];

    if (modelWords.some((word) => text.includes(word))) {
      return true;
    }

    /*
      Extra visuele fallback:
      modelfoto's zijn in deze galerij doorgaans duidelijk hoger
      dan de losse voor-/achter-/zijaanzichten.
    */
    const width = image.naturalWidth || 0;
    const height = image.naturalHeight || 0;

    if (width > 0 && height > 0) {
      return height / width >= 1.14;
    }

    return false;
  };

  const applyRequestedOrder = (pages, selectedPrinting) => {
    /*
      BELANGRIJK:
      Blanco blijft EXACT in de volgorde die nu goed staat:
      oude 3 → 4 → 5 → 1 → 2.
    */
    if (pages.length < 5) {
      return pages.slice();
    }

    const firstFive = FIVE_IMAGE_ORDER
      .map((position) => pages[position])
      .filter(Boolean);

    let ordered = firstFive.concat(pages.slice(5));

    /*
      Alleen bij "T-shirt bedrukken":
      dezelfde basisvolgorde behouden, maar modelfoto's met
      bedrukte T-shirts eerst tonen. Binnen de modelgroep en
      binnen de productgroep blijft de bestaande volgorde behouden.
    */
    if (isPrintedSelection(selectedPrinting)) {
      const modelPages = ordered.filter(isModelPage);
      const productPages = ordered.filter((page) => !isModelPage(page));

      if (modelPages.length) {
        ordered = [...modelPages, ...productPages];
      }
    }

    return ordered;
  };

  const ensureStyles = () => {
    let style = document.getElementById('ShailoGalleryFinalEffects');

    if (!style) {
      style = document.createElement('style');
      style.id = 'ShailoGalleryFinalEffects';
      document.head.appendChild(style);
    }

    style.textContent = `
      /* =====================================================
         Transparante weergave van het galerijvlak
         LET OP: een witte achtergrond die IN het bronbestand zit
         kan CSS niet echt verwijderen.
      ===================================================== */
      [data-shailo-book-showcase] .shailo-book-page,
      [data-shailo-book-showcase] .shailo-book-page__zoom,
      [data-shailo-book-showcase] .shailo-book-page__image {
        background: transparent !important;
      }

      [data-shailo-book-showcase] .shailo-book-page__zoom {
        position: relative !important;
        overflow: visible !important;
        isolation: isolate;
      }

      [data-shailo-book-showcase] .shailo-book-page__image {
        position: relative;
        z-index: 2;
        object-fit: contain !important;
      }

      /* Bliksem/static na omslag uitgeschakeld */
      [data-shailo-book-showcase] .shailo-book-electric {
        display: none !important;
      }

      /* =====================================================
         BLADZIJDE OMSLAG
      ===================================================== */
      [data-shailo-book-showcase] [data-shailo-book-page] {
        transform-style: preserve-3d;
        will-change: transform, opacity, filter;
        backface-visibility: hidden;
      }

      [data-shailo-book-showcase] [data-shailo-book-page].shailo-page-shake {
        animation: shailoPageShakeFinal .18s linear 2;
      }

      [data-shailo-book-showcase] [data-shailo-book-page].shailo-page-leave-next {
        animation: shailoPageLeaveNextFinal .72s cubic-bezier(.22,.68,.25,1) forwards;
        transform-origin: left center;
      }

      [data-shailo-book-showcase] [data-shailo-book-page].shailo-page-leave-prev {
        animation: shailoPageLeavePrevFinal .72s cubic-bezier(.22,.68,.25,1) forwards;
        transform-origin: right center;
      }

      [data-shailo-book-showcase] [data-shailo-book-page].shailo-page-enter-next {
        animation: shailoPageEnterNextFinal .66s cubic-bezier(.22,.68,.25,1) forwards;
        transform-origin: right center;
      }

      [data-shailo-book-showcase] [data-shailo-book-page].shailo-page-enter-prev {
        animation: shailoPageEnterPrevFinal .66s cubic-bezier(.22,.68,.25,1) forwards;
        transform-origin: left center;
      }

      /* =====================================================
         GROEIENDE ELEKTRISCHE STATIC / BLIKSEMSLAG
      ===================================================== */
      [data-shailo-book-showcase] .shailo-book-electric {
        position: absolute !important;
        inset: 2% !important;
        z-index: 35 !important;
        pointer-events: none !important;
        opacity: 0;
        overflow: visible;
      }

      [data-shailo-book-showcase].shailo-electric-active .shailo-book-electric {
        opacity: 1;
      }

      [data-shailo-book-showcase] .shailo-book-electric__arc {
        position: absolute;
        height: 2px;
        border-radius: 999px;
        opacity: 0;
        transform-origin: left center;
        background:
          linear-gradient(
            90deg,
            transparent 0%,
            rgba(255,255,255,.95) 12%,
            rgba(255,232,126,1) 35%,
            rgba(255,255,255,1) 52%,
            rgba(229,185,60,.96) 74%,
            transparent 100%
          );
        box-shadow:
          0 0 4px rgba(255,255,255,1),
          0 0 11px rgba(255,236,152,.95),
          0 0 22px rgba(229,185,60,.72),
          0 0 38px rgba(188,130,24,.35);
        filter: brightness(1.35);
      }

      [data-shailo-book-showcase] .shailo-book-electric__arc--1 {
        width: 52%;
        top: 15%;
        left: 6%;
        transform: rotate(-10deg) scaleX(.04);
      }

      [data-shailo-book-showcase] .shailo-book-electric__arc--2 {
        width: 62%;
        right: 2%;
        top: 48%;
        transform: rotate(8deg) scaleX(.04);
        transform-origin: right center;
      }

      [data-shailo-book-showcase] .shailo-book-electric__arc--3 {
        width: 48%;
        left: 24%;
        bottom: 12%;
        transform: rotate(-5deg) scaleX(.04);
      }

      [data-shailo-book-showcase].shailo-electric-active
      .shailo-book-electric__arc--1 {
        animation: shailoGrowingStaticOne .64s steps(5,end) forwards;
      }

      [data-shailo-book-showcase].shailo-electric-active
      .shailo-book-electric__arc--2 {
        animation: shailoGrowingStaticTwo .68s steps(5,end) .05s forwards;
      }

      [data-shailo-book-showcase].shailo-electric-active
      .shailo-book-electric__arc--3 {
        animation: shailoGrowingStaticThree .58s steps(5,end) .10s forwards;
      }


      /* Meer echte bladzijde-omslag */
      [data-shailo-book-showcase] [data-shailo-book-page] {
        perspective: 1800px;
      }

      [data-shailo-book-showcase] [data-shailo-book-page]::before {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 18;
        pointer-events: none;
        opacity: 0;
        border-radius: inherit;
        background:
          linear-gradient(
            90deg,
            rgba(0,0,0,.42) 0%,
            rgba(0,0,0,.12) 18%,
            rgba(255,255,255,.12) 50%,
            rgba(0,0,0,.34) 100%
          );
      }

      [data-shailo-book-showcase]
      [data-shailo-book-page].shailo-page-leave-next::before {
        animation: shailoPaperShadeNext .78s ease-in-out forwards;
      }

      [data-shailo-book-showcase]
      [data-shailo-book-page].shailo-page-leave-prev::before {
        animation: shailoPaperShadePrev .78s ease-in-out forwards;
      }

      /* =====================================================
         LANGZAME OMTREKGLOED — ÉÉN VOLLEDIG RONDJE
         Start na iedere bladzijde-omslag, daarna rustig vervagen.
      ===================================================== */
      [data-shailo-book-page].shailo-page-settle-glow
      .shailo-book-page__zoom {
        position: relative !important;
        isolation: isolate;
      }

      [data-shailo-book-page].shailo-page-settle-glow
      .shailo-book-page__zoom::before {
        content: "";
        position: absolute;
        z-index: 4;
        inset: -18px;
        border-radius: 22px;
        padding: 2px;
        pointer-events: none;

        background:
          conic-gradient(
            from 0deg,
            transparent 0deg,
            transparent 318deg,
            rgba(226,177,45,.10) 326deg,
            rgba(238,196,70,.32) 333deg,
            rgba(255,226,126,.72) 339deg,
            rgba(255,255,255,.98) 344deg,
            rgba(255,234,151,.94) 350deg,
            rgba(228,181,49,.56) 356deg,
            transparent 360deg
          );

        -webkit-mask:
          linear-gradient(#000 0 0) content-box,
          linear-gradient(#000 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;

        opacity: 0;
        transform: rotate(0deg);

        filter:
          drop-shadow(0 0 8px rgba(255,255,255,.98))
          drop-shadow(0 0 18px rgba(255,234,152,.92))
          drop-shadow(0 0 34px rgba(232,185,54,.72))
          drop-shadow(0 0 56px rgba(190,132,25,.34));

        animation:
          shailoSlowOutlineTrace 7.2s linear forwards;
      }

      [data-shailo-book-page].shailo-page-settle-glow
      .shailo-book-page__zoom::after {
        content: "";
        position: absolute;
        z-index: 3;
        inset: -14px;
        border-radius: 18px;
        pointer-events: none;
        opacity: 0;

        box-shadow:
          0 0 12px rgba(255,255,255,.16),
          0 0 28px rgba(236,195,68,.18),
          0 0 52px rgba(212,158,34,.10),
          inset 0 0 12px rgba(236,195,68,.06);

        animation:
          shailoSoftHaloFade 7.2s ease-in-out forwards;
      }

      /*
        Bij transparante PNG/WebP volgt deze zachte drop-shadow
        tegelijkertijd rustig de zichtbare vorm van het object.
      */
      [data-shailo-book-page].shailo-page-settle-glow
      .shailo-book-page__image {
        animation: shailoSilhouetteGlow 7.2s ease-in-out forwards;
      }

      [data-shailo-book-prev]:disabled,
      [data-shailo-book-next]:disabled {
        opacity: .28 !important;
        cursor: default !important;
      }

      @keyframes shailoPageShakeFinal {
        0%,100% { transform: translateX(0) rotateZ(0); }
        25% { transform: translateX(-3px) rotateZ(-.25deg); }
        50% { transform: translateX(3px) rotateZ(.25deg); }
        75% { transform: translateX(-2px) rotateZ(-.15deg); }
      }

      @keyframes shailoPageLeaveNextFinal {
        0%   { opacity:1; transform:perspective(1800px) rotateY(0deg) translateX(0) scale(1); filter:brightness(1); }
        28%  { opacity:1; transform:perspective(1800px) rotateY(-20deg) translateX(-2%) scale(.997); filter:brightness(1.06); }
        62%  { opacity:.97; transform:perspective(1800px) rotateY(-68deg) translateX(-5%) scale(.982); filter:brightness(.9); }
        100% { opacity:0; transform:perspective(1800px) rotateY(-118deg) translateX(-10%) scale(.95); filter:brightness(.55); }
      }

      @keyframes shailoPageLeavePrevFinal {
        0%   { opacity:1; transform:perspective(1800px) rotateY(0deg) translateX(0) scale(1); filter:brightness(1); }
        28%  { opacity:1; transform:perspective(1800px) rotateY(20deg) translateX(2%) scale(.997); filter:brightness(1.06); }
        62%  { opacity:.97; transform:perspective(1800px) rotateY(68deg) translateX(5%) scale(.982); filter:brightness(.9); }
        100% { opacity:0; transform:perspective(1800px) rotateY(118deg) translateX(10%) scale(.95); filter:brightness(.55); }
      }

      @keyframes shailoPageEnterNextFinal {
        0%   { opacity:.12; transform:perspective(1800px) rotateY(38deg) translateX(4%) scale(.975); filter:brightness(.72); }
        58%  { opacity:.86; transform:perspective(1800px) rotateY(8deg) translateX(1%) scale(.995); filter:brightness(.96); }
        100% { opacity:1; transform:perspective(1800px) rotateY(0deg) translateX(0) scale(1); filter:brightness(1); }
      }

      @keyframes shailoPageEnterPrevFinal {
        0%   { opacity:.12; transform:perspective(1800px) rotateY(-38deg) translateX(-4%) scale(.975); filter:brightness(.72); }
        58%  { opacity:.86; transform:perspective(1800px) rotateY(-8deg) translateX(-1%) scale(.995); filter:brightness(.96); }
        100% { opacity:1; transform:perspective(1800px) rotateY(0deg) translateX(0) scale(1); filter:brightness(1); }
      }

      @keyframes shailoPaperShadeNext {
        0%{opacity:0;transform:translateX(22%);}
        20%{opacity:.24;}
        58%{opacity:.64;transform:translateX(-2%);}
        100%{opacity:0;transform:translateX(-28%);}
      }

      @keyframes shailoPaperShadePrev {
        0%{opacity:0;transform:translateX(-22%);}
        20%{opacity:.24;}
        58%{opacity:.64;transform:translateX(2%);}
        100%{opacity:0;transform:translateX(28%);}
      }
        100% {
          opacity: 1;
          transform: perspective(1550px) rotateY(0) translateX(0) scale(1);
          filter: brightness(1);
        }
      }

      @keyframes shailoGrowingStaticOne {
        0%   { opacity:0; transform:rotate(-10deg) scaleX(.04); }
        14%  { opacity:1; transform:rotate(-7deg) scaleX(.28); }
        32%  { opacity:.32; transform:rotate(-12deg) scaleX(.52); }
        52%  { opacity:1; transform:rotate(-8deg) scaleX(.78); }
        72%  { opacity:.5; transform:rotate(-11deg) scaleX(1); }
        88%  { opacity:1; transform:rotate(-9deg) scaleX(1.18); }
        100% { opacity:0; transform:rotate(-10deg) scaleX(1.28); }
      }

      @keyframes shailoGrowingStaticTwo {
        0%   { opacity:0; transform:rotate(8deg) scaleX(.04); }
        15%  { opacity:1; transform:rotate(5deg) scaleX(.24); }
        34%  { opacity:.26; transform:rotate(11deg) scaleX(.49); }
        54%  { opacity:1; transform:rotate(7deg) scaleX(.76); }
        74%  { opacity:.48; transform:rotate(10deg) scaleX(.98); }
        90%  { opacity:1; transform:rotate(6deg) scaleX(1.16); }
        100% { opacity:0; transform:rotate(8deg) scaleX(1.3); }
      }

      @keyframes shailoGrowingStaticThree {
        0%   { opacity:0; transform:rotate(-5deg) scaleX(.04); }
        18%  { opacity:1; transform:rotate(-2deg) scaleX(.3); }
        38%  { opacity:.2; transform:rotate(-8deg) scaleX(.55); }
        58%  { opacity:1; transform:rotate(-4deg) scaleX(.83); }
        78%  { opacity:.45; transform:rotate(-7deg) scaleX(1.03); }
        92%  { opacity:1; transform:rotate(-3deg) scaleX(1.2); }
        100% { opacity:0; transform:rotate(-5deg) scaleX(1.3); }
      }

      @keyframes shailoSlowOutlineTrace {
        0% {
          opacity: 0;
          transform: rotate(0deg);
        }

        3% {
          opacity: .55;
        }

        8% {
          opacity: 1;
        }

        88% {
          opacity: 1;
        }

        94% {
          opacity: .82;
        }

        98% {
          opacity: .38;
        }

        100% {
          opacity: 0;
          transform: rotate(360deg);
        }
      }
        4% {
          opacity: .75;
        }
        10% {
          opacity: 1;
        }
        86% {
          opacity: 1;
        }
        94% {
          opacity: .70;
        }
        98% {
          opacity: .30;
        }
        100% {
          opacity: 0;
          transform: rotate(360deg);
        }
      }
        6% {
          opacity: 1;
        }
        82% {
          opacity: 1;
        }
        94% {
          opacity: .55;
        }
        100% {
          opacity: 0;
          transform: rotate(360deg);
        }
      }

      @keyframes shailoSoftHaloFade {
        0% {
          opacity: 0;
        }
        8% {
          opacity: .18;
        }
        22% {
          opacity: .30;
        }
        68% {
          opacity: .26;
        }
        88% {
          opacity: .15;
        }
        100% {
          opacity: 0;
        }
      }

      @keyframes shailoSilhouetteGlow {
        0% {
          filter:
            drop-shadow(0 0 0 rgba(255,255,255,0))
            drop-shadow(0 0 0 rgba(244,204,82,0))
            brightness(1);
          transform: translateZ(0) scale(1);
        }

        10% {
          filter:
            drop-shadow(0 0 5px rgba(255,255,255,.42))
            drop-shadow(0 0 12px rgba(255,227,124,.36))
            drop-shadow(0 0 22px rgba(229,181,47,.24))
            brightness(1.03);
          transform: translateZ(0) scale(1.004);
        }

        28% {
          filter:
            drop-shadow(0 0 8px rgba(255,255,255,.62))
            drop-shadow(0 0 18px rgba(255,225,118,.55))
            drop-shadow(0 0 34px rgba(229,181,47,.38))
            brightness(1.07);
          transform: translateZ(0) scale(1.009);
        }

        62% {
          filter:
            drop-shadow(0 0 9px rgba(255,255,255,.68))
            drop-shadow(0 0 20px rgba(255,225,118,.60))
            drop-shadow(0 0 38px rgba(229,181,47,.42))
            brightness(1.08);
          transform: translateZ(0) scale(1.01);
        }

        84% {
          filter:
            drop-shadow(0 0 6px rgba(255,255,255,.42))
            drop-shadow(0 0 14px rgba(255,225,118,.34))
            drop-shadow(0 0 24px rgba(229,181,47,.22))
            brightness(1.035);
          transform: translateZ(0) scale(1.005);
        }

        100% {
          filter:
            drop-shadow(0 0 0 rgba(255,255,255,0))
            drop-shadow(0 0 0 rgba(244,204,82,0))
            brightness(1);
          transform: translateZ(0) scale(1);
        }
      }
        10% {
          filter:
            drop-shadow(0 0 3px rgba(255,255,255,.24))
            drop-shadow(0 0 8px rgba(231,188,63,.20));
          transform: translateZ(0) scale(1.002);
        }
        32% {
          filter:
            drop-shadow(0 0 6px rgba(255,255,255,.34))
            drop-shadow(0 0 15px rgba(231,188,63,.30));
          transform: translateZ(0) scale(1.006);
        }
        68% {
          filter:
            drop-shadow(0 0 6px rgba(255,255,255,.32))
            drop-shadow(0 0 14px rgba(231,188,63,.28));
          transform: translateZ(0) scale(1.006);
        }
        88% {
          filter:
            drop-shadow(0 0 3px rgba(255,255,255,.18))
            drop-shadow(0 0 8px rgba(231,188,63,.16));
          transform: translateZ(0) scale(1.002);
        }
        100% {
          filter:
            drop-shadow(0 0 0 rgba(255,255,255,0))
            drop-shadow(0 0 0 rgba(231,188,63,0));
          transform: translateZ(0) scale(1);
        }
      }
        12% {
          filter:
            drop-shadow(0 0 3px rgba(255,255,255,.20))
            drop-shadow(0 0 7px rgba(231,188,63,.18));
        }
        48% {
          filter:
            drop-shadow(0 0 5px rgba(255,255,255,.28))
            drop-shadow(0 0 11px rgba(231,188,63,.24));
        }
        78% {
          filter:
            drop-shadow(0 0 3px rgba(255,255,255,.16))
            drop-shadow(0 0 7px rgba(231,188,63,.14));
        }
        100% {
          filter:
            drop-shadow(0 0 0 rgba(255,255,255,0))
            drop-shadow(0 0 0 rgba(231,188,63,0));
        }
      }
        20% {
          filter:
            drop-shadow(0 0 8px rgba(255,255,255,.62))
            drop-shadow(0 0 18px rgba(231,188,63,.48));
        }
        62% {
          filter:
            drop-shadow(0 0 5px rgba(255,255,255,.3))
            drop-shadow(0 0 12px rgba(231,188,63,.26));
        }
        100% {
          filter:
            drop-shadow(0 0 0 rgba(255,255,255,0))
            drop-shadow(0 0 0 rgba(231,188,63,0));
        }
      }

      /* Lightbox/zoom behouden */
      .shailo-book-lightbox {
        position: fixed;
        inset: 0;
        z-index: 999999;
        background: rgba(0,0,0,.92);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 32px;
        backdrop-filter: blur(8px);
      }

      .shailo-book-lightbox[hidden] {
        display: none !important;
      }

      .shailo-book-lightbox__image {
        display: block;
        max-width: min(94vw, 1600px);
        max-height: 90vh;
        object-fit: contain;
      }

      .shailo-book-lightbox__close {
        position: fixed;
        top: 20px;
        right: 24px;
        width: 46px;
        height: 46px;
        border-radius: 50%;
        border: 1px solid rgba(231,193,79,.7);
        color: #f0ce69;
        background: rgba(8,8,9,.92);
        font-size: 30px;
        cursor: pointer;
      }

      @media (prefers-reduced-motion: reduce) {
        [data-shailo-book-showcase] [data-shailo-book-page],
        [data-shailo-book-showcase] .shailo-book-electric__arc,
        [data-shailo-book-page].shailo-page-settle-glow .shailo-book-page__zoom::after,
        [data-shailo-book-page].shailo-page-settle-glow .shailo-book-page__image {
          animation-duration: .01ms !important;
          animation-iteration-count: 1 !important;
        }
      }
    `;
  };

  const initGallery = () => {
    if (!isCorrectProduct()) return;

    ensureStyles();

    const gallery = document.querySelector('[data-shailo-book-showcase]');
    if (!gallery) return;

    const allPages = [...gallery.querySelectorAll('[data-shailo-book-page]')];
    const prev = gallery.querySelector('[data-shailo-book-prev]');
    const next = gallery.querySelector('[data-shailo-book-next]');
    const current = gallery.querySelector('[data-shailo-book-current]');
    const total = gallery.querySelector('[data-shailo-book-total]');
    const stage = gallery.querySelector('[data-shailo-book-stage]');

    if (!allPages.length || !stage) return;

    let visiblePages = [];
    let index = 0;
    let busy = false;
    let touchStartX = 0;
    let touchStartY = 0;

    const clearAnimationClasses = () => {
      allPages.forEach((page) => {
        page.classList.remove(
          'shailo-page-shake',
          'shailo-page-leave-next',
          'shailo-page-leave-prev',
          'shailo-page-enter-next',
          'shailo-page-enter-prev'
        );
      });
    };

    const triggerSettleGlow = (page) => {
      if (!page) return;

      /*
        Werkt generiek op iedere huidige of later toegevoegde galerijpagina.
        Zodra een afbeelding actief wordt krijgt hij exact hetzelfde highlight-effect.
      */
      page.classList.remove('shailo-page-settle-glow');
      void page.offsetWidth;
      page.classList.add('shailo-page-settle-glow');

      window.setTimeout(() => {
        page.classList.remove('shailo-page-settle-glow');
      }, 7450);
    };

    const applyFilter = () => {
      const selectedColor = getSelectedOption('color');
      const selectedPrinting = getSelectedOption('printing');

      let matched = allPages.filter((page) =>
        pageMatchesSelection(page, selectedColor, selectedPrinting)
      );

      /*
        Geen terugval naar alle afbeeldingen.
        Als een combinatie nog niet correct gekoppeld is, tonen we
        slechts één veilige afbeelding.
      */
      if (!matched.length) {
        const globalPage = allPages.find((page) => {
          const colors = readTokens(page, 'data-colors');
          const printings = readTokens(page, 'data-printings');

          return colors.includes('*') && printings.includes('*');
        });

        matched = globalPage ? [globalPage] : allPages.slice(0, 1);
      }

      visiblePages = applyRequestedOrder(matched, selectedPrinting);

      clearAnimationClasses();

      allPages.forEach((page) => {
        const visible = visiblePages.includes(page);

        page.hidden = !visible;
        page.classList.remove('is-active');
        page.setAttribute('aria-hidden', 'true');
      });

      index = 0;

      if (visiblePages[0]) {
        visiblePages[0].hidden = false;
        visiblePages[0].classList.add('is-active');
        visiblePages[0].setAttribute('aria-hidden', 'false');

        triggerSettleGlow(visiblePages[0]);
      }

      if (current) current.textContent = visiblePages.length ? '1' : '0';
      if (total) total.textContent = String(visiblePages.length);

      if (prev) prev.disabled = visiblePages.length <= 1;
      if (next) next.disabled = visiblePages.length <= 1;
    };

    const sync = () => {
      visiblePages.forEach((page, i) => {
        const active = i === index;

        page.hidden = false;
        page.classList.toggle('is-active', active);
        page.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      allPages
        .filter((page) => !visiblePages.includes(page))
        .forEach((page) => {
          page.hidden = true;
          page.classList.remove('is-active');
          page.setAttribute('aria-hidden', 'true');
        });

      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(visiblePages.length);
    };

    const goTo = (nextIndex, direction) => {
      if (
        busy ||
        visiblePages.length < 2 ||
        nextIndex === index ||
        nextIndex < 0 ||
        nextIndex >= visiblePages.length
      ) {
        return;
      }

      busy = true;

      const oldPage = visiblePages[index];
      const newPage = visiblePages[nextIndex];

      clearAnimationClasses();

      oldPage.classList.add('shailo-page-shake');

      window.setTimeout(() => {
        oldPage.classList.remove('shailo-page-shake');
        oldPage.classList.add(
          direction === 'prev'
            ? 'shailo-page-leave-prev'
            : 'shailo-page-leave-next'
        );

        newPage.hidden = false;
        newPage.classList.add('is-active');
        newPage.setAttribute('aria-hidden', 'false');
        newPage.classList.add(
          direction === 'prev'
            ? 'shailo-page-enter-prev'
            : 'shailo-page-enter-next'
        );

        window.setTimeout(() => {
          oldPage.classList.remove('is-active');
          oldPage.setAttribute('aria-hidden', 'true');

          index = nextIndex;
          sync();

          /*
            Na de omslag: één rustige goud/witte ronde gloed
            en daarna volledig rustig.
          */
          triggerSettleGlow(newPage);

          window.setTimeout(() => {
            clearAnimationClasses();
            busy = false;
          }, 180);
        }, 680);
      }, 190);
    };

    const goNext = () => {
      const nextIndex =
        index >= visiblePages.length - 1 ? 0 : index + 1;

      goTo(nextIndex, 'next');
    };

    const goPrev = () => {
      const nextIndex =
        index <= 0 ? visiblePages.length - 1 : index - 1;

      goTo(nextIndex, 'prev');
    };

    if (gallery.dataset.shailoFinalGalleryReady !== 'true') {
      gallery.dataset.shailoFinalGalleryReady = 'true';

      prev?.addEventListener('click', (event) => {
        event.preventDefault();
        goPrev();
      });

      next?.addEventListener('click', (event) => {
        event.preventDefault();
        goNext();
      });

      stage.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];

          const dx = touchStartX - touch.screenX;
          const dy = touchStartY - touch.screenY;

          if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;

          if (dx > 0) goNext();
          else goPrev();
        },
        { passive: true }
      );

      /* Filters opnieuw toepassen bij kleur of bedrukking. */
      document.addEventListener('change', (event) => {
        if (!isCorrectProduct()) return;

        if (event.target.matches('input[type="radio"], select')) {
          window.setTimeout(() => {
            busy = false;
            applyFilter();
          }, 140);
        }
      });

      document.addEventListener('shopify:section:load', () => {
        window.setTimeout(applyFilter, 120);
      });

      /* Zoom/lightbox behouden */
      const lightbox = document.querySelector('[data-shailo-lightbox]');
      const lightboxImage = lightbox?.querySelector('[data-shailo-lightbox-image]');
      const closeButton = lightbox?.querySelector('[data-shailo-lightbox-close]');

      const closeLightbox = () => {
        if (!lightbox) return;

        lightbox.hidden = true;
        document.documentElement.style.overflow = '';
      };

      gallery.addEventListener('click', (event) => {
        const zoomButton = event.target.closest('[data-shailo-zoom]');

        if (!zoomButton || !lightbox || !lightboxImage) return;

        const src = zoomButton.getAttribute('data-zoom-src');
        if (!src) return;

        lightboxImage.src = src;
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      });

      closeButton?.addEventListener('click', closeLightbox);

      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) {
          closeLightbox();
        }
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && lightbox && !lightbox.hidden) {
          closeLightbox();
        }
      });
    }

    applyFilter();
  };

  const start = () => {
    initGallery();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();